import React, { useState } from "react";

interface AthleteHeroBackgroundProps {
  src?: string | null;
  className?: string;
}

/**
 * Image de fond des écrans athlète, tolérante aux erreurs de chargement.
 * Si l'URL configurée ne peut pas être servie (asset expiré, domaine sans
 * proxy d'assets), l'image est retirée du DOM au lieu d'afficher le glyphe
 * d'image cassée d'iOS (« ? » bleu) au centre du hero.
 */
export const AthleteHeroBackground: React.FC<AthleteHeroBackgroundProps> = ({ src, className }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      onError={() => setFailed(true)}
      className={className ?? "absolute inset-0 h-full w-full object-cover"}
    />
  );
};
